import React from 'react';
import PropTypes from 'prop-types';
import { i18n } from '../../translate/i18n';
import { confirmable } from 'react-confirm';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { Typography } from '@mui/material';

const Confirm = ({ show, proceed, dismiss, cancel, confirmation, options }) => {
  return (
    <Dialog
      disableEscapeKeyDown={options.disableKeyDown}
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      open={show}
      onClose={dismiss}>
      <DialogTitle id="confirmation-dialog-title" style={{ color: options.titleColor }}>{options.title}</DialogTitle>
      <DialogContent dividers>
        <Typography variant='h6'>
          {confirmation}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => proceed('callback cancel')} color="primary">
          {i18n.t('btnConfirmDialog.cancel')}
        </Button>
        <Button onClick={() => cancel('callback ok')} color="primary">
        {i18n.t('btnConfirmDialog.ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

Confirm.propTypes = {
  show: PropTypes.bool,            // from confirmable. indicates if the dialog is shown or not.
  proceed: PropTypes.func,         // from confirmable. call to close the dialog with promise resolved.
  cancel: PropTypes.func,          // from confirmable. call to close the dialog with promise rejected.
  dismiss: PropTypes.func,         // from confirmable. call to only close the dialog.
  confirmation: PropTypes.string,  // arguments of your confirm function
  options: PropTypes.object        // arguments of your confirm function
}

export default confirmable(Confirm);